import { Line, Bar } from 'react-chartjs-2';
import 'chart.js/auto';
// Icons to use if needed later.
// import { LuChartLine, LuChartColumnBig } from 'react-icons/lu';

import { isNum, limitDecimal } from '@utils/helpers';

const options = {
	maintainAspectRatio: false,
	plugins: { legend: { display: false } },
	scales: {
		x: { ticks: { display: false } },
		y: { ticks: { display: false } },
	},
};

const chartTypes = { line: Line, bar: Bar };
const Chart = ({
	classname,
	property,
	detections,
	displayValue,
	min,
	max,
	type = 'line',
	...props
}) => {
	if (!property || !detections?.length) return null;

	const ChartComponent = chartTypes[type] ?? Line;

	const numBuckets = 10;
	const range = max - min;
	const bucketSize = range / numBuckets;

	if (!isFinite(range) || range <= 0) {
		console.error(`Invalid range: ${range}. min=${min}, max=${max}`);
		return null;
	}

	// Initialize buckets
	const buckets = [];
	for (let i = 0; i < numBuckets; i++) {
		const bucketMin = limitDecimal(min + i * bucketSize); //
		const bucketMax = limitDecimal(min + (i + 1) * bucketSize);
		buckets.push({
			min: bucketMin,
			max: bucketMax,
			count: 0,
		});
	}

	// Fill buckets with detection values
	for (const detection of detections) {
		if (classname !== detection.properties.classname) continue;
		const value = detection.properties[property];
		if (!isNum(value)) continue;

		// Find the bucket index for this value (floor so value falls into correct range)
		const bucketIndex = Math.floor((value - min) / bucketSize);

		// Clamp to valid bucket range (handle edge case where value === max)
		const clampedIndex = Math.min(Math.max(bucketIndex, 0), numBuckets - 1);

		// Increment the count for the appropriate bucket
		if (clampedIndex in buckets) buckets[clampedIndex].count += 1;
		else console.error(`Bucket index ${clampedIndex} not in buckets for value ${value}`);
	}

	const data = {
		// Generate center labels (~5%, ~15%, etc.) where each represents a range
		labels: buckets.map(({ min, max }) => `~${displayValue((min + max) / 2)}`),
		datasets: [
			{
				label: `Count`,
				data: buckets.map(({ count }) => count),

				fill: true,
				backgroundColor: '#20AC6B22',
				borderColor: '#20AC6B',

				tension: 0.1,
				borderWidth: 1,

				pointRadius: 4,
				pointHoverRadius: 6,
			},
		],
	};

	return (
		<div {...props}>
			<ChartComponent options={options} data={data} />
		</div>
	);
};

export default Chart;
